import React, { useEffect, useState, useRef } from "react";
import NavigateBackLogo from "../img/NavigateBackLogo.svg";
import Expand_left_light from "../img/Expand_left_light.svg";
import Expand_right_light from "../img/Expand_right_light.svg";
import info_light from "../img/info_light.svg";
import Tick from "../img/tick.svg";
import Add_round from "../img/Add_round.svg";
import Minus from "../img/Minus.svg";
import Close_round2 from "../img/Close_round2.svg";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBottom from "../img/ArrowBottom.svg";
import ComingSoon from "../img/SOON SVG (2).svg";
import api from "../../api/axiosInstance";
import CoupenSuccesGif from "../img/CoupenSuccesGif.gif";
import GifCoupon from "../img/GifCoupon.gif";
import editIcon from "../img/Edit_fill.svg";
import deleteIcon from "../img/deleteicon.svg";
import Close_roundClose from "../img/Close_roundClose.svg";
import axios from "axios";
import Header from "./Header";

const UpgradedPlan = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const location = useLocation();
  const { item_id, item_type, org_mapper_id, project_code } =
    location.state || {};
  const navigate = useNavigate();
  const totalContainers = 12; // For example, you have 12 containers in total
  const [activePlan, setActivePlan] = useState("yearly");
  const [currentPage, setCurrentPage] = useState(0);
  const [licensePlans, setLicensePlans] = useState([]);
  const [filterType, setFilterType] = useState("Year"); // or "Month"
  const [openTopupForPlan, setOpenTopupForPlan] = useState(null);
  const [selectedTopups, setSelectedTopups] = useState({});
  const [addonCartLoading, setAddonCartLoading] = useState(false);
  const topupRefs = useRef({});
  const toggleRefs = useRef({});
  const [loading, setLoading] = useState(true);
  const [cartData, setCartData] = useState(null);
  const [calculations, setCalculations] = useState(null);
  const [couponCode, setCouponCode] = useState(""); // Store the coupon code
  const [isCouponLoading, setIsCouponLoading] = useState(false); // Handle the loading state for the API call
  const cartRef = useRef(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [showCouponSuccessGif, setShowCouponSuccessGif] = useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [couponModalMessage, setCouponModalMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultAddress, setDefaultAddress] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [gstNo, setGstNo] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isFromKerala, setIsFromKerala] = useState(false);
  const [locations, setLocations] = useState([]);
  const [showPostalModal, setShowPostalModal] = useState(false);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isMessageModalOpen, setMessageModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [paymentDomain, setPaymentDomain] = useState("");
  const [isPaymentVerified, setIsPaymentVerified] = useState(false);
  const [paymentSuccessModalOpen, setPaymentSuccessModalOpen] = useState(false);
  const [transitionLoading, setTransitionLoading] = useState(false);

  // Handle plan toggle
  const handlePlanToggle = (planType) => {
    setActivePlan(planType);
    setFilterType(planType === "monthly" ? "Month" : "Year");
    setCurrentPage(0); // reset to first page
  };

  // Handle next page navigation
  const nextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1); // Go to the next page
    }
  };

  // Handle previous page navigation
  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1); // Go to the previous page
    }
  };

  // Get the current plans to display based on the active plan and current page
  const containersPerPage = screenWidth <= 640 ? 1 : 4;
  const totalPages = Math.ceil(licensePlans.length / containersPerPage);
  const startIndex = currentPage * containersPerPage;
  const endIndex = startIndex + containersPerPage;
  const plansToDisplayPage = licensePlans.slice(startIndex, endIndex);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth); // Update screenWidth on resize
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize); // Clean up listener
    };
  }, []);

  const fetchLicensePlans = async () => {
    setLoading(true);
    setLicensePlans([]);
    try {
      const response = await api.post(
        "/display/api/v1/display-license-for-upgrade",
        {
          org_mapper_id,
          project_code: project_code,
          filter_type: filterType,
          item_id,
        }
      );
      if (response.data?.status === "success") {
        setLicensePlans(response.data.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch license plans:", error);
      setLicensePlans([]);
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {
    if (org_mapper_id && item_id) {
      fetchLicensePlans();
    }
  }, [filterType]); // re-fetch on filter change

  const toggleTopupDropdown = (licenseId) => {
    setOpenTopupForPlan((prev) => (prev === licenseId ? null : licenseId));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openTopupForPlan) {
        const topupEl = topupRefs.current[openTopupForPlan];
        const toggleEl = toggleRefs.current[openTopupForPlan];
        if (
          topupEl &&
          !topupEl.contains(event.target) &&
          toggleEl &&
          !toggleEl.contains(event.target)
        ) {
          setOpenTopupForPlan(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openTopupForPlan]);

  const addPlanToCart = async (plan) => {
    try {
      // Filter the selected top-ups where count > 0
      const topUpData = Object.values(selectedTopups)
        .filter((item) => item.quantity > 0) // Only include top-ups with quantity > 0
        .map((item) => ({
          top_up_id: item.topup_id, // Include only the topup_id and count
          count: item.quantity, // Include count, no price
        }));

      // If no top-ups selected, pass an empty array
      const topUpDataToSend = topUpData.length > 0 ? topUpData : [];

      console.log("Top-up data to send:", topUpDataToSend); // Log the top-up data being sent to API

      // API call to add the plan to the cart
      const response = await api.post(
        "/display/api/v1/display-cart-data-for-upgrade",
        {
          item_id: plan.license_duration_id, // License ID for the plan
          org_mapper_id,
          item_type: item_type, // Plan type
          topu_up_data: topUpDataToSend, // Pass top-up data (can be empty)
        }
      );

      if (response.data?.status === "success") {
        setCartData(response.data.data?.cart_data); // Set the cart data response
        setCalculations(response.data.data.calculations);
        setSelectedTopups("");

        setTimeout(() => {
          if (cartRef.current) {
            window.scrollTo({
              top: cartRef.current.offsetTop - 50, // Adjust offset to add space above
              behavior: "smooth",
            });
          }
        }, 200); // Delay scroll by 200ms
      }
    } catch (error) {
      console.error("Error adding plan to cart:", error);
    }
  };

  const handleTopUpChange = (topUpId, change) => {
    setSelectedTopups((prev) => {
      const currentQty = prev[topUpId]?.quantity || 0;
      const newQty = Math.max(0, currentQty + change); // Ensure count is never negative
      return {
        ...prev,
        [topUpId]: {
          topup_id: topUpId,
          quantity: newQty,
        },
      };
    });
  };

  const handleAddToCart = () => {
    const topUpData = Object.values(selectedTopups);
    console.log("Top-up data to be sent to API:", topUpData); // Log the data
    addPlanToCart(topUpData);
  };

  const handleRemoveTopup = async (topupId, count) => {
    try {
      // Create the request body to set the top-up as inactive
      const topUpData = [
        {
          top_up_id: topupId,
          count: count, // Set count to 0 because we are removing it
          is_active: false, // Mark top-up as inactive
        },
      ];

      // Make API call to update the top-up status
      const response = await api.post(
        "/display/api/v1/display-cart-data-for-upgrade",
        {
          item_id: cartData.item_id, // The plan's item_id
          org_mapper_id, // Pass the org_mapper_id
          item_type: "license", // Item type (license)
          topu_up_data: topUpData, // Pass the top-up data to deactivate it
        }
      );

      if (response.data?.status === "success") {
        // Update cartData and recalculations based on the API response
        setCartData(response.data.data?.cart_data);
        setCalculations(response.data.data.calculations);
      }
    } catch (error) {
      console.error("Error removing top-up:", error);
    }
  };

  const handleApplyCoupon = async () => {
    if (!couponCode) {
      alert("Please enter a coupon code");
      return;
    }

    setIsCouponLoading(true);

    try {
      const response = await api.post("/display/api/v1/apply-coupon-upgrade", {
        cart_id: cartData?.id,
        coupon_id: cartData?.coupon_data?.id,
        coupon_code: couponCode,
        org_mapper_id: org_mapper_id,
      });

      if (response.data?.status === "success") {
        const couponDetails = response.data.data?.coupon_data || [];
        const calculations = response.data.data?.calculations;

        // Save current values
        let updatedValidity = cartData.validity;
        let updatedPrice = cartData.total_price;
        let updatedLimits = cartData.limits_data;
        let prevValidity = updatedValidity;
        let prevPrice = updatedPrice;
        let prevLimits = updatedLimits;

        couponDetails.forEach((detail) => {
          switch (detail.applying_type) {
            case "duration":
              updatedValidity = detail.data?.[0]?.updated || updatedValidity;
              break;
            case "price":
              updatedPrice = detail.data?.[0]?.updated || updatedPrice;
              break;
            case "limit":
              if (Array.isArray(detail.data)) {
                updatedLimits = detail.data.map((l) => ({
                  based_on: l.based_on,
                  count: l.updated,
                }));
              }
              break;
          }
        });

        setCartData((prev) => ({
          ...prev,
          validity: updatedValidity,
          total_price: updatedPrice,
          limits_data: updatedLimits,
          prev_validity: prevValidity,
          prev_total_price: prevPrice,
          prev_limits_data: prevLimits,
          is_coupon_applied: true,
          applied_coupon_code: couponCode, // track applied code
        }));

        setCalculations(calculations);
        setShowCouponSuccessGif(true); // ✅ Show GIF

        setTimeout(() => {
          setShowCouponSuccessGif(false); // ✅ Hide after 3s
        }, 2000);

        setCouponModalMessage("Coupon applied successfully!");
        setShowCouponModal(true);
      } else {
        setCouponModalMessage(
          `Failed to apply coupon: ${response.data?.message}`
        );
        setShowCouponModal(true);
      }
    } catch (error) {
      console.error("Error applying coupon:", error);
      setCouponModalMessage(
        "An error occurred while applying the coupon. Please try again."
      );
      setShowCouponModal(true);
    } finally {
      setIsCouponLoading(false);
    }
  };

  const handleRemoveCoupon = () => {
    // Revert cartData to previous values
    setCartData((prev) => ({
      ...prev,
      validity: prev.prev_validity,
      total_price: prev.prev_total_price,
      limits_data: prev.prev_limits_data,
      is_coupon_applied: false,
    }));

    setCouponCode(""); // clear input
    setCalculations((prevCalc) => ({
      ...prevCalc,
      total_offer: 0,
      grant_total: prevCalc.total_plan_price + prevCalc.tax_value, // Recalculate without offer
    }));

    setShowCouponSuccessGif(false);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleAddressModal = () => {
    setIsAddressModalOpen(!isAddressModalOpen);
  };

  const handleSetDefaultAddress = async (id) => {
    try {
      const token = localStorage.getItem("accessToken"); // Get the token from session storage

      if (!token) {
        console.error("No token found");
        return;
      }

      // Send PATCH request to update the address to default
      const response = await api.patch(
        `/display/api/v1/patch-delete-billing-address/${id}`,
        {
          is_default: true,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        // On successful response, update the address state
        const updatedAddresses = addresses.map(
          (address) =>
            address.id === id
              ? { ...address, is_default: true } // Update the clicked address to default
              : { ...address, is_default: false } // Set the rest to non-default
        );
        setAddresses(updatedAddresses);
        fetchAddresses();
      } else {
        console.error("Failed to update address:", response.data);
      }
    } catch (error) {
      console.error("Error updating address:", error);
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      fetchAddresses();
    }
  }, [isModalOpen]);

  const fetchAddresses = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }
    try {
      const response = await api.get("/display/api/v1/list-billing-address", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        // Add any authorization token if required
      });

      // No need to call response.json() with Axios, the data is already parsed
      const data = response.data;

      if (data.status === "success") {
        setAddresses(data.data);

        // Set the default address if available
        const defaultAddr = data.data.find((address) => address.is_default);
        setDefaultAddress(defaultAddr);
        console.log("default address", defaultAddr);
      } else {
        console.error("Error fetching addresses", data.response_code);
      }
    } catch (error) {
      console.error("Error fetching addresses", error);
    }
  };

  const handleUpdate = (index) => {
    const addressToEdit = addresses[index];
    setSelectedAddress(addressToEdit);
    setAddress(addressToEdit.address_1);
    setPostalCode(addressToEdit.pincode);
    setCity(addressToEdit.city);
    setDistrict(addressToEdit.district);
    setState(addressToEdit.state);
    setCountry(addressToEdit.country);
    setGstNo(addressToEdit.gstNo);
    setIsEditModalOpen(true); // Open Edit Modal
  };

  const toggleDeleteModal = (id = null) => {
    setSelectedAddressId(id);
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  const handlePostalCodeChange = async (e) => {
    const enteredPostalCode = e.target.value;
    setPostalCode(enteredPostalCode);

    // Only call API when exactly 6 digits
    if (!enteredPostalCode || enteredPostalCode.length !== 6) {
      setShowPostalModal(false);
      setLocations([]);
      setSelectedLocation(null);
      setIsFromKerala(false);
      return;
    }

    try {
      const res = await axios.get(
        `https://api.postalpincode.in/pincode/${enteredPostalCode}`
      );

      const first = Array.isArray(res.data) ? res.data[0] : null;

      if (first?.Status === "Success" && Array.isArray(first?.PostOffice)) {
        // Normalize to your existing structure: {id, postalLocation, district, state, country, postalCode}
        const normalized = first.PostOffice.map((po, idx) => ({
          id: `${enteredPostalCode}-${idx}`,
          postalLocation: po.Name, // used in modal label + city assignment
          district: po.District,
          state: po.State,
          country: po.Country,
          postalCode: enteredPostalCode,
        }));

        const foundKerala = normalized.some(
          (loc) => (loc.state || "").toLowerCase() === "kerala"
        );

        setIsFromKerala(foundKerala);
        setLocations(normalized);
        setShowPostalModal(true);
      } else {
        setShowPostalModal(false);
        setLocations([]);
        setSelectedLocation(null);
        setIsFromKerala(false);
      }
    } catch (error) {
      console.error("Error fetching postal data:", error);
      setShowPostalModal(false);
      setLocations([]);
      setSelectedLocation(null);
      setIsFromKerala(false);
    }
  };

  const handleSaveAddress = async () => {
    if (
      !address.trim() ||
      !city.trim() ||
      !state.trim() ||
      !postalCode.trim() ||
      !district.trim() ||
      !country.trim()
    ) {
      showModal("Please fill in all required fields before saving.");
      return;
    }
    console.log("Save clicked with data:", {
      address_1: address,
      city,
      state,
      pincode: postalCode,
      latitude: latitude || 0,
      longitude: longitude || 0,
      district,
      country,
      license_number: gstNo || "", // ✅ Correctly pass gstNo as license_number
      is_from_kerala: isFromKerala,
    });

    try {
      const res = await api.post(
        "/display/api/v1/create-billing-address",
        {
          address_1: address,
          city,
          state,
          pincode: postalCode,
          latitude: latitude || 0,
          longitude: longitude || 0,
          district,
          country,
          license_number: gstNo || "", // ✅ This is required by API
          is_from_kerala: isFromKerala,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Billing address created:", res.data);
      fetchAddresses();

      // Clear form inputs
      setAddress("");
      setCity("");
      setCountry("");
      setDistrict("");
      setGstNo("");
      setPostalCode("");
      setState("");

      setIsAddressModalOpen(false); // Close the modal on success
    } catch (err) {
      console.error("Error creating billing address:", err.response || err);
    }
  };

  const showModal = (message) => {
    alert(message); // Replace with your modal or toast if needed
  };

  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);
  };

  const handleEditAddress = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }

    try {
      const updatedAddress = {
        address_1: address,
        pincode: postalCode,
        city,
        district,
        state,
        country,
        gstNo,
      };

      // Make PATCH request to the server
      const response = await api.patch(
        `/display/api/v1/patch-delete-billing-address/${selectedAddress.id}`,
        updatedAddress,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        // On successful update, update the address list
        const updatedAddresses = addresses.map((addr) =>
          addr.id === selectedAddress.id ? { ...addr, ...updatedAddress } : addr
        );
        setAddresses(updatedAddresses);
        toggleEditModal(); // Close the modal
      } else {
        console.error("Failed to update address");
      }
    } catch (error) {
      console.error("Error updating address:", error);
    }
  };

  const handleDeleteAccount = async () => {
    // Retrieve the access token from session storage
    const accessToken = localStorage.getItem("accessToken");

    // Check if access token exists; if not, prompt the user to log in
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }
    // 🛑 Prevent deleting the default address
    if (selectedAddressId === defaultAddress?.id) {
      setMessage("You cannot delete the default billing address.");
      setMessageType("error");
      setMessageModalOpen(true);
      return;
    }

    try {
      // Make a DELETE request to the backend API to delete the address
      const response = await api.delete(
        `/display/api/v1/patch-delete-billing-address/${selectedAddressId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Add Authorization header with access token
          },
        }
      );

      // If the response status is 200, it means the delete operation was successful
      if (response.status === 200) {
        fetchAddresses();
        // Filter the addresses list to remove the deleted address
        setAddresses(
          addresses.filter((address) => address.id !== selectedAddressId)
        );
        // Set the success message
        setMessage("Address successfully deleted!");
        setIsDeleteModalOpen(false);
        // Set the message type as success
        setMessageType("success");
        // Open the success modal
        setMessageModalOpen(true);
      } else {
        // If the status is not 200, set the error message
        setMessage("Failed to delete the address. Please try again.");
        // Set the message type as error
        setMessageType("error");
        // Open the error modal
        setMessageModalOpen(true);
      }
    } catch (error) {
      // Handle any errors that occur during the delete request
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        // If the error response contains a message, display it
        setMessage(`Error: ${error.response.data.message}`);
      } else {
        // If no error message is returned, display a generic error message
        setMessage("An error occurred. Please try again.");
      }
      // Set the message type as error
      setMessageType("error");
      // Open the error modal
      setMessageModalOpen(true);
    }
  };

  const handleLocationSelection = (location) => {
    setSelectedLocation(location); // Update selected location with the details
  };

  const handleModalClose = () => {
    setShowPostalModal(false);
  };

  const handleConfirmLocation = () => {
    if (selectedLocation) {
      // If we're editing an address
      if (isEditModalOpen && selectedAddress) {
        setCity(selectedLocation.postalLocation); // Use postal location for city
        setDistrict(selectedLocation.district); // Use selected district
        setState(selectedLocation.state); // Use selected state
        setCountry(selectedLocation.country); // Use selected country
        setPostalCode(selectedLocation.postalCode); // Use postal code

        // Close the postal location modal and open the edit address modal
        setShowPostalModal(false);
        setIsEditModalOpen(true); // Open the edit modal
      } else {
        // If we're adding a new address
        setCity(selectedLocation.postalLocation); // Use postal location for city
        setDistrict(selectedLocation.district); // Use selected district
        setState(selectedLocation.state); // Use selected state
        setCountry(selectedLocation.country); // Use selected country
        setPostalCode(selectedLocation.postalCode); // Use postal code

        // Close the postal location modal and open the add address modal
        setShowPostalModal(false);
        setIsAddressModalOpen(true); // Open the add address modal
      }
    }
  };

  const handleProceedToPayment = async () => {
    try {
      setIsLoading(true);

      const requestBody = {
        address_id: defaultAddress?.id, // use selected address
        coupon_id: cartData?.is_coupon_applied
          ? cartData?.coupon_data?.id
          : null,
        item_id: cartData?.item_id,
        item_type: "license",
        coupon_code: cartData?.is_coupon_applied
          ? cartData?.applied_coupon_code
          : null,
        cart_type: "upgrade",
        org_mapper_id: org_mapper_id,
      };

      console.log("Initiating payment with body: ", requestBody);

      const response = await api.post(
        "/display/api/v1/initiate-renew-payment",
        requestBody
      );

      if (response.data.status === "success") {
        const paymentData = response.data.data;

        // ✅ Check if amount is zero
        if (parseFloat(paymentData.total_amount) === 0) {
          // Directly call verify API
          await handlePaymentSuccess(
            {
              razorpay_order_id: paymentData.razorpay_code,
              razorpay_payment_id: paymentData.razorpay_key,
            },
            paymentData.purchase_id
          );

          // call Razorpay
        } else {
          // 💳 Proceed with Razorpay
          openRazorpay(
            paymentData.razorpay_key,
            paymentData.razorpay_code,
            paymentData.total_amount,
            paymentData.purchase_id
          );
        }
      } else {
        setMessage("Failed to initiate payment: " + response.data.message);
        setMessageType("error");
        setMessageModalOpen(true);
      }
    } catch (error) {
      console.error("Error initiating payment:", error);
      setMessage("An error occurred while initiating payment.");
      setMessageType("error");
      setMessageModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const openRazorpay = (key, orderId, amount, purchase_id) => {
    const options = {
      key: key,
      amount: amount * 100, // convert to paisa
      currency: "INR",
      name: "Your Company",
      description: "License Upgrade Payment",
      order_id: orderId,
      handler: function (response) {
        console.log("Payment successful:", response);
        handlePaymentSuccess(response, purchase_id); // verify with backend
      },
      prefill: {
        name: "",
        email: "",
        contact: "",
      },
      theme: {
        color: "#9061DB",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handlePaymentSuccess = async (paymentResponse, purchase_id) => {
    console.log("Payment response:", paymentResponse);

    const token = localStorage.getItem("accessToken");

    const payload = {
      razorpay_order_id: paymentResponse.razorpay_order_id,
      razorpay_payment_id: paymentResponse.razorpay_payment_id,
      razorpay_signature: paymentResponse.razorpay_signature,
      purchase_id: purchase_id,
    };

    try {
      const response = await api.post(
        "/display/api/v1/verify-purchase",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "success") {
        console.log("Final confirmation response:", response.data);
        setPaymentDomain(response.data.data.domain); // store the domain
        setIsPaymentVerified(true); // mark as verified
        setPaymentSuccessModalOpen(true); // open modal
      } else {
        alert(response.data.message || "Final payment confirmation failed.");
      }
    } catch (error) {
      console.error("Error confirming payment:", error);
      setMessage("Something went wrong while confirming payment.");
      setMessageType("error");
      setMessageModalOpen(true);
    }
  };

  const toggleMessageModal = () => {
    setMessageModalOpen(!isMessageModalOpen);
    setIsDeleteModalOpen(!isDeleteModalOpen);
    setMessage(""); // Reset message when modal is toggled
  };

  useEffect(() => {
    setTransitionLoading(true);
    const timeout = setTimeout(() => {
      setTransitionLoading(false);
    }, 500); // Delay (in ms) to simulate loading while switching

    return () => clearTimeout(timeout);
  }, [activePlan]);

  return (
    <div>
      {/* <div
        className="h-[62px] px-5 w-full bg-[#4C3A68] flex items-center  sticky top-0 z-50 "
        style={{ boxShadow: "0px 4px 5px 0px #8C62E280" }}
      >
        <img
          src={NavigateBackLogo}
          onClick={() => navigate(-1)}
          alt=""
          className="cursor-pointer hover:bg-[#5D4D76] rounded-full p-1"
        />
      </div> */}
      <Header></Header>

      <div className="mt-5 flex flex-col  items-center justify-center">
        <span className="text-3xl font-bold">Our plans</span>
        <span className="text-lg sm:text-left text-center my-4">
          That’s why our pricing is flexible, affordable, and tailored to
          support businesses at every stage.
        </span>
      </div>

      <div className="relative">
        <div
          className=" absolute rounded-full px-3 py-1.5 font-semibold text-xs  flex items-center gap-3 transform -translate-x-1/2 -translate-y-1/2  left-1/2"
          style={{
            background: "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
          }}
        >
          <span
            onClick={() => handlePlanToggle("monthly")}
            className={`flex justify-center py-1.5 w-20  rounded-full text-sm font-bold cursor-pointer ${
              activePlan === "monthly"
                ? "bg-white text-[#9367D7]"
                : "text-white"
            }`}
          >
            Monthly
          </span>
          <span
            onClick={() => handlePlanToggle("yearly")}
            className={`flex justify-center py-1.5 w-20 rounded-full text-sm font-bold cursor-pointer ${
              activePlan === "yearly" ? "bg-white text-[#9367D7]" : "text-white"
            }`}
          >
            Yearly
          </span>
        </div>

        <div
          style={{
            background:
              "linear-gradient(270deg, #F1EFFF 0%, rgba(241, 239, 255, 0) 51.92%, #F1EFFF 100%)",
          }}
          className="rounded-md mx-5 my-5 sm:mx-10 sm:my-10 "
        >
          {transitionLoading ? (
            <div className="flex justify-center items-center h-[500px]">
              <div className="w-10 h-10 border-4 border-[#9367D7] border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : (
            <>
              {activePlan === "monthly" && (
                <div className="flex sm:flex-row justify-around py-10 ">
                  {/* Monthly Plan Content */}
                  {loading ? (
                    <p className="text-white text-center">Loading plans...</p>
                  ) : licensePlans.length === 0 ? (
                    <div className="flex justify-center items-center">
                      <img src={ComingSoon} alt="" className="rounded-2xl" />
                    </div>
                  ) : (
                    <div className="flex flex-col sm:flex-row justify-between items-center w-full">
                      {licensePlans.length > containersPerPage && (
                        <img
                          src={Expand_left_light}
                          alt="Previous"
                          onClick={prevPage}
                          className="cursor-pointer"
                          style={{ opacity: currentPage === 0 ? 0.4 : 1 }}
                        />
                      )}
                      {plansToDisplayPage.map((plan) => (
                        <div
                          key={plan.license_duration_id}
                          className="w-full sm:w-64 mt-4 flex flex-col min-h-[380px] items-center justify-between py-5 rounded-2xl mx-2 bg-white shadow-md"
                        >
                          <div className="flex flex-col gap-2 items-center justify-center ">
                            <h1 className="text-sm font-bold">
                              {plan.license_details.name}
                            </h1>
                            <span className="text-[#848484] font-bold line-through text-lg">
                              ₹ {plan.price}
                            </span>
                            {plan.discount_details.updated_price && (
                              <div className="flex flex-col items-center">
                                <div className="flex gap-1 text-xs">
                                  <span>Offer amount</span>
                                  <img src={info_light} alt="" />
                                </div>

                                <span className="text-xl line-through font-bold text-[#848484]">
                                  ₹ {plan.discount_details.updated_price}
                                </span>
                              </div>
                            )}

                            <div className="flex flex-col items-center">
                              <div className="flex gap-1 text-xs">
                                <span>Reduction amount</span>
                                <img src={info_light} alt="" />
                              </div>
                              <span className="text-2xl font-bold ">
                                ₹ {plan.reduction_amount}
                              </span>
                            </div>
                            {plan.unit_price && (
                              <span className="h-10 w-40 border border-1 bg-[#E6E2FF] text-sm font-semibold rounded-full flex justify-center items-center">
                                Only {plan.unit_price}
                              </span>
                            )}

                            <span className="text-xs">{plan.duration}</span>
                          </div>

                          <span
                            className={`text-sm w-40 border my-2 rounded-full h-10 flex items-center justify-center ${
                              plan.is_already_purchased === true ||
                              plan.is_already_purchased === "true"
                                ? "border-[#8C8C8C] text-[#8C8C8C] cursor-default"
                                : "border-[#9367D7] text-[#9367D7] cursor-pointer"
                            }`}
                            onClick={() => {
                              if (
                                plan.is_already_purchased !== true &&
                                plan.is_already_purchased !== "true"
                              ) {
                                addPlanToCart(plan); // Trigger API call when "Add plan" is clicked
                              }
                            }}
                          >
                            {plan.is_already_purchased === true ||
                            plan.is_already_purchased === "true"
                              ? "Current plan"
                              : "Add plan"}
                          </span>

                          <span className="font-medium text-xs px-6 my-2 text-center">
                            {plan.license_details.description}
                          </span>
                          <h1 className="w-64 px-5 font-semibold">
                            Features :
                          </h1>
                          <div className="flex flex-col  my-2 gap-3 w-full px-5">
                            {plan.conditions.map((condition, idx) => (
                              <div key={idx} className="flex gap-1">
                                <img src={Tick} alt="" />
                                <span className="text-xs">{condition}</span>
                              </div>
                            ))}
                          </div>

                          <div className="relative w-full flex justify-center mt-3">
                            <div
                              ref={(el) =>
                                (toggleRefs.current[
                                  plan.license_details.license_id
                                ] = el)
                              }
                              onClick={() =>
                                setOpenTopupForPlan((prev) =>
                                  prev === plan.license_details.license_id
                                    ? null
                                    : plan.license_details.license_id
                                )
                              }
                              className="flex w-[90%] px-4 py-1 justify-between text-sm font-bold rounded-full cursor-pointer"
                              style={{
                                color: "#9367D7",
                                border: "1px solid #9367D7",
                              }}
                            >
                              <span>Top-Up Plan</span>
                              <img src={ArrowBottom} alt="" />
                            </div>

                            {openTopupForPlan ===
                              plan.license_details.license_id && (
                              <div
                                ref={(el) =>
                                  (topupRefs.current[
                                    plan.license_details.license_id
                                  ] = el)
                                }
                                className="absolute z-10 mt-8 w-full bg-white rounded-b-2xl shadow flex flex-col items-center"
                              >
                                {plan.top_ups && plan.top_ups.length > 0 ? (
                                  <>
                                    {plan.top_ups.map((topup) => (
                                      <div
                                        key={topup.top_up_id}
                                        className="flex justify-between items-center mt-2 mb-2 px-2 py-2 text-sm hover:bg-gray-100 rounded-xl w-[90%]"
                                        style={{ border: "1px solid #9367D7" }}
                                      >
                                        <div className="flex flex-col gap-1">
                                          <span className="text-xs">
                                            {topup.name}
                                          </span>
                                          <span className="text-[#ACA7A7] text-xs">
                                            ₹{topup.price}
                                            <span>/qty</span>
                                          </span>
                                        </div>
                                        <div className="flex gap-1 items-center">
                                          <img
                                            src={Minus}
                                            alt="Decrease"
                                            className="cursor-pointer w-[20px]"
                                            onClick={() => {
                                              setSelectedTopups((prev) => {
                                                const currentQty =
                                                  prev[topup.top_up_id]
                                                    ?.quantity || 0;
                                                const newQty = Math.max(
                                                  0,
                                                  currentQty - 1
                                                );
                                                return {
                                                  ...prev,
                                                  [topup.top_up_id]: {
                                                    topup_id: topup.top_up_id,
                                                    quantity: newQty,
                                                    price: topup.price,
                                                  },
                                                };
                                              });
                                            }}
                                          />
                                          <input
                                            type="number"
                                            min={0}
                                            value={
                                              selectedTopups[topup.top_up_id]
                                                ?.quantity || 0
                                            }
                                            onChange={(e) => {
                                              const quantity = Math.max(
                                                0,
                                                parseInt(e.target.value, 10) ||
                                                  0
                                              );
                                              setSelectedTopups((prev) => ({
                                                ...prev,
                                                [topup.top_up_id]: {
                                                  topup_id: topup.top_up_id,
                                                  quantity,
                                                  price: topup.price,
                                                },
                                              }));
                                            }}
                                            className="bg-[#E6E2FF] h-6 w-8 rounded-lg text-center"
                                          />
                                          <img
                                            src={Add_round}
                                            alt="Increase"
                                            className="cursor-pointer w-[20px]"
                                            onClick={() => {
                                              setSelectedTopups((prev) => {
                                                const currentQty =
                                                  prev[topup.top_up_id]
                                                    ?.quantity || 0;
                                                const newQty = currentQty + 1;
                                                return {
                                                  ...prev,
                                                  [topup.top_up_id]: {
                                                    topup_id: topup.top_up_id,
                                                    quantity: newQty,
                                                    price: topup.price,
                                                  },
                                                };
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    ))}

                                    <div className="w-[90%] border-t border-gray-300 py-2 flex justify-between items-center">
                                      <p className="text-xs sm:text-sm font-semibold text-black">
                                        Total Top-Up Payment
                                      </p>
                                      <p className="text-xs sm:text-sm font-semibold text-black">
                                        ₹
                                        {Object.values(selectedTopups).reduce(
                                          (sum, item) =>
                                            sum + item.quantity * item.price,
                                          0
                                        )}
                                      </p>
                                    </div>

                                    <div className="mb-3 w-full flex">
                                      <button
                                        style={{
                                          background:
                                            "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                                        }}
                                        className="mx-auto w-[90%] rounded-full p-1 font-bold text-white"
                                        onClick={() =>
                                          console.log(
                                            "addTopupToCart placeholder"
                                          )
                                        }
                                        disabled={addonCartLoading}
                                      >
                                        {addonCartLoading
                                          ? "Adding..."
                                          : "Add top up"}
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <div className="px-4 py-2 text-sm text-gray-500">
                                    No top-ups available
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                      {licensePlans.length > containersPerPage && (
                        <img
                          className="cursor-pointer"
                          src={Expand_right_light}
                          alt="Next"
                          onClick={nextPage}
                          style={{
                            opacity: currentPage === totalPages - 1 ? 0.4 : 1,
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
              {activePlan === "yearly" && (
                <div className="flex sm:flex-row justify-around py-10 ">
                  {/* Monthly Plan Content */}
                  {loading ? (
                    <p className="text-white text-center">Loading plans...</p>
                  ) : licensePlans.length === 0 ? (
                    <div>
                      <img src={ComingSoon} alt="" className="rounded-2xl" />
                    </div>
                  ) : (
                    <div className="flex sm:flex-row justify-center items-center w-full">
                      {licensePlans.length > containersPerPage && (
                        <img
                          src={Expand_left_light}
                          alt="Previous"
                          onClick={prevPage}
                          className="cursor-pointer w-10 h-10"
                          style={{ opacity: currentPage === 0 ? 0.4 : 1 }}
                        />
                      )}
                      {plansToDisplayPage.map((plan) => (
                        <div
                          key={plan.license_duration_id}
                          className="w-full sm:w-64 mt-4 flex flex-col min-h-[380px] items-center justify-between py-5 rounded-2xl mx-2 bg-white shadow-md"
                        >
                          <div className="flex flex-col gap-2 items-center justify-center ">
                            <h1 className="text-sm font-bold">
                              {plan.license_details.name}
                            </h1>
                            <span className="text-[#848484] font-bold line-through text-lg">
                              ₹ {plan.price}
                            </span>
                            {plan.discount_details.updated_price && (
                              <div className="flex flex-col items-center">
                                <div className="flex gap-1 text-xs">
                                  <span>Offer amount</span>
                                  <img src={info_light} alt="" />
                                </div>

                                <span className="text-xl line-through font-bold text-[#848484]">
                                  ₹ {plan.discount_details.updated_price}
                                </span>
                              </div>
                            )}

                            <div className="flex flex-col items-center">
                              <div className="flex gap-1 text-xs">
                                <span>Reduction amount</span>
                                <img src={info_light} alt="" />
                              </div>
                              <span className="text-2xl font-bold ">
                                ₹ {plan.reduction_amount}
                              </span>
                            </div>
                            {plan.unit_price && (
                              <span className="h-10 w-40 border border-1 bg-[#E6E2FF] text-sm font-semibold rounded-full flex justify-center items-center">
                                Only {plan.unit_price}
                              </span>
                            )}

                            <span className="text-xs">{plan.duration}</span>
                          </div>

                          <span
                            className={`text-sm w-40 border my-2 rounded-full h-10 flex items-center justify-center ${
                              plan.is_already_purchased === true ||
                              plan.is_already_purchased === "true"
                                ? "border-[#8C8C8C] text-[#8C8C8C] cursor-default"
                                : "border-[#9367D7] text-[#9367D7] cursor-pointer"
                            }`}
                            onClick={() => {
                              if (
                                plan.is_already_purchased !== true &&
                                plan.is_already_purchased !== "true"
                              ) {
                                addPlanToCart(plan); // Trigger API call when "Add plan" is clicked
                              }
                            }}
                          >
                            {plan.is_already_purchased === true ||
                            plan.is_already_purchased === "true"
                              ? "Current plan"
                              : "Add Plan"}
                          </span>

                          <span className="font-medium text-xs px-6 my-2 text-center">
                            {plan.license_details.description}
                          </span>
                          <h1 className="w-64 px-5 font-semibold">
                            Features :
                          </h1>
                          <div className="flex flex-col  my-2 gap-3 w-full px-5">
                            {plan.conditions.map((condition, idx) => (
                              <div key={idx} className="flex gap-1">
                                <img src={Tick} alt="" />
                                <span className="text-xs">{condition}</span>
                              </div>
                            ))}
                          </div>

                          <div className="relative w-full flex justify-center mt-3">
                            <div
                              ref={(el) =>
                                (toggleRefs.current[
                                  plan.license_details.license_id
                                ] = el)
                              }
                              onClick={() =>
                                setOpenTopupForPlan((prev) =>
                                  prev === plan.license_details.license_id
                                    ? null
                                    : plan.license_details.license_id
                                )
                              }
                              className="flex w-[90%] px-4 py-1 justify-between text-sm font-bold rounded-full cursor-pointer"
                              style={{
                                color: "#9367D7",
                                border: "1px solid #9367D7",
                              }}
                            >
                              <span>Top-Up Plan</span>
                              <img src={ArrowBottom} alt="" />
                            </div>

                            {openTopupForPlan ===
                              plan.license_details.license_id && (
                              <div
                                ref={(el) =>
                                  (topupRefs.current[
                                    plan.license_details.license_id
                                  ] = el)
                                }
                                className="absolute z-10 mt-8 w-full bg-white rounded-b-2xl shadow flex flex-col items-center"
                              >
                                {plan.top_ups && plan.top_ups.length > 0 ? (
                                  <>
                                    {plan.top_ups.map((topup) => (
                                      <div
                                        key={topup.top_up_id}
                                        className="flex justify-between items-center mt-2 mb-2 px-2 py-2 text-sm hover:bg-gray-100 rounded-xl w-[90%]"
                                        style={{ border: "1px solid #9367D7" }}
                                      >
                                        <div className="flex flex-col gap-1">
                                          <span className="text-xs">
                                            {topup.name}
                                          </span>
                                          <span className="text-[#ACA7A7] text-xs">
                                            ₹{topup.price}
                                            <span>/qty</span>
                                          </span>
                                        </div>
                                        <div className="flex gap-1 items-center">
                                          <img
                                            src={Minus}
                                            alt="Decrease"
                                            className="cursor-pointer w-[20px]"
                                            onClick={() => {
                                              setSelectedTopups((prev) => {
                                                const currentQty =
                                                  prev[topup.top_up_id]
                                                    ?.quantity || 0;
                                                const newQty = Math.max(
                                                  0,
                                                  currentQty - 1
                                                );
                                                return {
                                                  ...prev,
                                                  [topup.top_up_id]: {
                                                    topup_id: topup.top_up_id,
                                                    quantity: newQty,
                                                    price: topup.price,
                                                  },
                                                };
                                              });
                                            }}
                                          />
                                          <input
                                            type="number"
                                            min={0}
                                            value={
                                              selectedTopups[topup.top_up_id]
                                                ?.quantity || 0
                                            }
                                            onChange={(e) => {
                                              const quantity = Math.max(
                                                0,
                                                parseInt(e.target.value, 10) ||
                                                  0
                                              );
                                              setSelectedTopups((prev) => ({
                                                ...prev,
                                                [topup.top_up_id]: {
                                                  topup_id: topup.top_up_id,
                                                  quantity,
                                                  price: topup.price,
                                                },
                                              }));
                                            }}
                                            className="bg-[#E6E2FF] h-6 w-8 rounded-lg text-center"
                                          />
                                          <img
                                            src={Add_round}
                                            alt="Increase"
                                            className="cursor-pointer w-[20px]"
                                            onClick={() => {
                                              setSelectedTopups((prev) => {
                                                const currentQty =
                                                  prev[topup.top_up_id]
                                                    ?.quantity || 0;
                                                const newQty = currentQty + 1;
                                                return {
                                                  ...prev,
                                                  [topup.top_up_id]: {
                                                    topup_id: topup.top_up_id,
                                                    quantity: newQty,
                                                    price: topup.price,
                                                  },
                                                };
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    ))}

                                    <div className="w-[90%] border-t border-gray-300 py-2 flex justify-between items-center">
                                      <p className="text-xs sm:text-sm font-semibold text-black">
                                        Total Top-Up Payment
                                      </p>
                                      <p className="text-xs sm:text-sm font-semibold text-black">
                                        ₹
                                        {Object.values(selectedTopups).reduce(
                                          (sum, item) =>
                                            sum + item.quantity * item.price,
                                          0
                                        )}
                                      </p>
                                    </div>

                                    <div className="mb-3 w-full flex">
                                      <button
                                        style={{
                                          background:
                                            "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                                        }}
                                        className="mx-auto w-[90%] rounded-full p-1 font-bold text-white"
                                        onClick={() => {
                                          setOpenTopupForPlan(null);
                                        }}
                                        disabled={addonCartLoading}
                                      >
                                        {addonCartLoading ? "Adding..." : "Add"}
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <div className="px-4 py-2 text-sm text-gray-500">
                                    No top-ups available
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                      {licensePlans.length > containersPerPage && (
                        <img
                          className="cursor-pointer w-10 h-10"
                          src={Expand_right_light}
                          alt="Next"
                          onClick={nextPage}
                          style={{
                            opacity: currentPage === totalPages - 1 ? 0.4 : 1,
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className=" mx-5 my-5 sm:mx-10 sm:my-10" ref={cartRef}>
        {cartData ? (
          <div className="">
            <div className="sm:flex hidden mt-3">
              <div className="w-full bg-[#CEC7FF4D] px-4 py-2 flex text-xs font-semibold">
                <span className=" w-[30%]">Plan</span>
                <span className=" w-[20%]">Validity</span>
                <span className=" w-[20%]">Limits</span>
                <span className=" w-[30%]">Price</span>
              </div>
            </div>

            <div
              className=" mt-3 border border-[#D9D9D9] rounded-lg px-4 py-5"
              style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
            >
              <div className="w-full flex sm:flex-row flex-col gap-1 sm:items-center">
                <span className=" w-full  sm:w-[30%] flex sm:justify-start justify-between items-center gap-3">
                  <span className="text-sm font-semibold">
                    {cartData?.item_name}
                  </span>
                </span>
                <span className="text-sm mb-1 w-[20%]">
                  {cartData?.prev_validity &&
                  cartData?.prev_validity !== cartData?.validity ? (
                    <div className="flex flex-col">
                      <span className="line-through decoration-red-500 text-[#8C8C8C] text-xs">
                        {cartData.prev_validity}
                      </span>
                      <span>{cartData.validity}</span>
                    </div>
                  ) : (
                    cartData.validity
                  )}
                </span>
                <span className=" w-[20%]"></span>
                <div className="w-full flex items-center justify-between sm:w-[30%]">
                  {cartData?.prev_total_price &&
                  cartData?.prev_total_price !== cartData?.total_price ? (
                    <div className="flex flex-col">
                      <span className="line-through decoration-red-500 text-[#8C8C8C] text-lg">
                        ₹{cartData.prev_total_price}
                      </span>
                      <span className="text-lg  font-medium">
                        ₹{cartData.total_price}
                      </span>
                    </div>
                  ) : (
                    <span className="sm:text-lg text-sm">
                      ₹{cartData.total_price}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex mt-2">
                <span className="text-xs text-[#8C8C8C] w-[30%]">
                  {cartData?.limits_data[0]?.limit_name}
                </span>
                <span className="text-sm w-[20%]"></span>
                <span className="text-xs w-[20%]">
                  {cartData?.prev_limits_data &&
                  cartData.prev_limits_data[0]?.count !==
                    cartData?.limits_data[0]?.count ? (
                    <div className="flex flex-col">
                      <span className="line-through text-[#8C8C8C]">
                        {cartData.prev_limits_data[0]?.count}
                      </span>
                      <span>{cartData.limits_data[0]?.count}</span>
                    </div>
                  ) : (
                    cartData.limits_data[0]?.count
                  )}
                </span>
                <span className="text-lg w-[30%]"></span>
              </div>
            </div>

            {cartData?.topup_data.length > 0 &&
              cartData?.topup_data.map((topUp, id) => (
                <div
                  key={id}
                  className=" mt-3 border border-[#D9D9D9] rounded-lg px-4 py-5"
                  style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
                >
                  <div className="w-full flex">
                    <div className=" w-full relative flex  items-center gap-3">
                      <span className="text-sm font-semibold">
                        Top up plans
                      </span>
                    </div>
                  </div>
                  <div className="flex mt-2 sm:flex-row flex-col items-start  sm:items-center justify-around">
                    <span className="text-xs text-[#8C8C8C] w-[30%]">
                      {topUp.topup_id_name}
                    </span>
                    <span className="text-sm  sm:w-[20%]"></span>
                    <span className="text-xs sm:w-[20%]">
                      {topUp.limits_data[0]?.count}
                    </span>
                    <span className="text-lg w-full sm:w-[30%] flex justify-between items-center">
                      <span>₹{topUp.total_price}</span>
                      <div className="flex w-[73%] justify-between">
                        <div className="flex gap-2 items-center">
                          <img src={Minus} alt="" />
                          <input
                            type="number"
                            readOnly
                            className="bg-[#E6E2FF] h-6 w-8 rounded-lg text-center"
                          />
                          <img src={Add_round} alt="" />
                        </div>
                        <div className="flex gap-3 items-center">
                          <span className="text-xs text-[#8C8C8C]">
                            ₹ {topUp.total_price} /qty
                          </span>

                          <img
                            src={Close_round2}
                            alt="Remove"
                            className="w-4 h-4 cursor-pointer"
                            onClick={() =>
                              handleRemoveTopup(
                                topUp.top_up_id,
                                topUp.limits_data[0]?.count
                              )
                            } // Call remove function with top-up id and plan id
                          />
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              ))}

            <div className="relative">
              {showCouponSuccessGif && (
                <div className="absolute top-2 transform -translate-y-1/2 -translate-x-1/2 right-3 w-28 ">
                  <img src={GifCoupon} alt="Coupon Applied" className="" />
                </div>
              )}
              {showCouponSuccessGif && (
                <div className="absolute top-2 w-28 transform -translate-y-1/2 right-0">
                  <img
                    src={CoupenSuccesGif}
                    alt="Coupon Applied"
                    className=""
                  />
                </div>
              )}
            </div>

            {cartData?.is_coupon_have ? (
              <div
                className="flex justify-between border border-[#D9D9D9] rounded-lg mt-3 px-4 py-5"
                style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
              >
                <div className="flex flex-col text-[#8C8C8C] text-xs">
                  <span>{cartData?.coupon_data?.name}</span>
                  <span>{cartData?.coupon_data?.description}</span>
                </div>

                <div className="relative sm:w-3/12">
                  <input
                    type="text"
                    placeholder="Enter coupon code"
                    className="border rounded px-3 py-2 border-[#9367D7] w-full"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                    disabled={cartData?.is_coupon_applied} // disable if applied
                  />

                  {/* Apply / Remove logic */}
                  {cartData?.is_coupon_applied ? (
                    <span
                      className="absolute right-[8px] top-[10px] text-[#9367D7] text-sm font-semibold cursor-pointer"
                      onClick={() => {
                        setCouponCode("");
                        setCartData((prev) => ({
                          ...prev,
                          is_coupon_applied: false,
                          applied_coupon_code: null,
                          validity: prev.prev_validity,
                          total_price: prev.prev_total_price,
                          limits_data: prev.prev_limits_data,
                          // Optionally reset calculations too
                        }));
                      }}
                    >
                      Remove
                    </span>
                  ) : (
                    <button
                      className="absolute right-[4px] top-[4px] h-8 px-3 rounded text-white font-semibold"
                      style={{
                        background:
                          "linear-gradient(270deg, #9062DC 0%, #8877F3 100%)",
                      }}
                      onClick={handleApplyCoupon}
                    >
                      Apply
                    </button>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        ) : null}

        {calculations ? (
          <div
            className="mt-3 border border-[#D9D9D9] rounded-lg px-2 py-5 "
            style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
          >
            <span className="font-semibold text-sm px-2">Price details</span>

            <div className="flex flex-col bg-[#CEC7FF4D] rounded-md px-2 mt-3">
              <div className="w-full flex mt-3 items-center ">
                <span className="text-sm font-semibold  w-1/2">
                  {cartData?.item_name}
                </span>
                <span className="text-lg w-1/2 text-[#8C8C8C] line-through decoration-red-500 ">
                  ₹ {calculations.total_price}
                </span>
              </div>
              <div className="w-full flex mt-3 items-center">
                <span className="text-xs text-[#8C8C8C] w-1/2">
                  Reduction amount
                </span>
                <span className="text-lg w-1/2">
                  ₹ {calculations.reduction_amount}
                </span>
              </div>
            </div>
            <div className="w-full flex mt-3 px-2 items-center">
              <span className="text-xs text-[#8C8C8C] w-1/2">Top up plan</span>
              <span className="text-lg w-1/2">
                ₹ {calculations.total_plan_price}
              </span>
            </div>
            {cartData?.is_coupon_have ? (
              <div className="w-full flex mt-3 px-2 items-center">
                <span className="text-xs text-[#8C8C8C] w-1/2">
                  Discount by coupon
                </span>
                <span className="text-lg w-1/2">
                  ₹ {calculations.total_offer}
                </span>
              </div>
            ) : null}

            <div className="w-full flex mt-3 px-2 items-center">
              <span className="text-xs text-[#8C8C8C] w-1/2">
                Tax @ {calculations.tax_percentage}%
              </span>
              <span className="text-lg w-1/2">
                ₹ {calculations.percentage_value} {calculations.tax_value}
              </span>
            </div>
            <div className="w-full flex mt-3 items-center px-2">
              <span className="text-xl w-1/2">Total amount</span>
              <div className="w-1/2 flex justify-between">
                <span className="text-lg w-1/2">
                  ₹ {calculations.grant_total}
                </span>
                <button
                  onClick={toggleModal}
                  style={{
                    background:
                      "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                  }}
                  className="text-white rounded h-8 px-1 sm:px-3 text-sm font-semibold flex justify-center items-center"
                >
                  Check out
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {showCouponModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg w-1/2 shadow-md p-6 max-w-sm text-center">
            <h2 className="text-xl font-semibold mb-2">Notice</h2>
            <p className="text-sm mb-4">{couponModalMessage}</p>
            <button
              className="bg-[#9367D7] text-white rounded px-4 py-2"
              onClick={() => setShowCouponModal(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white w-3/4 md:w-1/2 p-6 rounded-lg">
            <h1 className="mt-4 text-black text-inter text-xl font-semibold">
              Billing Address
            </h1>

            <div className="w-full h-[158px] bg-white rounded-lg border border-[#D9D9D9] flex flex-col mt-4">
              {/* Top Half */}
              <div className="w-full h-1/2 bg-[#F7F2FF] border-b border-gray-300 flex items-center justify-between px-4 rounded-tl-lg rounded-tr-lg">
                <h2 className="text-lg font-inter font-semibold text-gray-800">
                  Default address
                </h2>
                <button
                  className="text-white text-sm font-medium px-4 py-2 rounded-md"
                  style={{
                    background:
                      "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                  }}
                  onClick={toggleAddressModal}
                >
                  Add a new address
                </button>
              </div>

              {/* Bottom Half */}
              <div className="w-full h-1/2 flex flex-col justify-center px-4">
                {defaultAddress ? (
                  <h2 className="text-sm font-semibold text-black text-inter">
                    {defaultAddress.address_1}, {defaultAddress.city},{" "}
                    {defaultAddress.state}, {defaultAddress.pincode},{" "}
                    {defaultAddress.district}, {defaultAddress.country}
                  </h2>
                ) : (
                  <p className="text-sm text-gray-500">
                    No default address available
                  </p>
                )}
              </div>
            </div>

            {/* Address List */}
            <div className="overflow-x-auto mt-6">
              <div className="flex space-x-4">
                {addresses.length > 0 ? (
                  // Sort the addresses so the default address comes first
                  addresses
                    .sort(
                      (a, b) => (b.is_default ? 1 : 0) - (a.is_default ? 1 : 0)
                    ) // Sort addresses with default first
                    .map((address, index) => (
                      <div
                        key={index}
                        className="flex-shrink-0 w-[400px] h-[158px] bg-white border border-[#D9D9D9] rounded-md px-2 flex"
                      >
                        {/* Address Content (on the left side, 90% width) */}
                        <div className="flex-1">
                          <h2 className="text-sm font-semibold text-black text-inter px-2 py-2">
                            {address.address_1}, {address.city}, {address.state}
                            , {address.pincode}, {address.district},{" "}
                            {address.country}
                          </h2>
                        </div>

                        <div className="w-[10%] flex flex-col items-center justify-between gap-2 px-2 py-2">
                          {/* Custom Checkbox */}
                          <div className="relative">
                            <input
                              type="checkbox"
                              checked={address.is_default}
                              onChange={() =>
                                handleSetDefaultAddress(address.id)
                              } // Trigger onChange to set default
                              className="w-5 h-5 cursor-pointer"
                              style={{
                                appearance: "none",
                                borderRadius: "4px",
                                border: "2px solid #9061DB",
                                backgroundColor: address.is_default
                                  ? "#9061DB"
                                  : "transparent", // Conditional background
                              }}
                            />

                            {/* Checkmark (tick) with inline styles */}
                            {address.is_default && (
                              <div
                                style={{
                                  color: "white",
                                  fontSize: "16px",
                                  fontWeight: "bold", // Added bold for better visibility
                                  position: "absolute",
                                  bottom: "4px",
                                  right: "3px", // Position the checkmark inside the checkbox
                                }}
                              >
                                ✓
                              </div>
                            )}
                          </div>

                          {/* Update Icon */}
                          <img
                            src={editIcon} // Replace with the actual path to your image
                            alt="Update"
                            className="w-5 h-5 cursor-pointer" // Fixed size for consistency
                            onClick={() => handleUpdate(index)} // Call your update function here
                          />

                          {/* Delete Icon */}
                          <img
                            src={deleteIcon} // Replace with the actual path to your image
                            alt="Delete"
                            className="w-5 h-5 cursor-pointer" // Fixed size for consistency
                            onClick={() => toggleDeleteModal(address.id)} // Open Delete Modal with selected address ID
                          />
                        </div>
                      </div>
                    ))
                ) : (
                  <p className="text-sm text-gray-500">
                    No addresses available
                  </p>
                )}
              </div>
            </div>

            {/* Button Container for Cancel and Proceed */}
            <div className="flex justify-end gap-2 mt-4">
              {/* Cancel Button */}

              <button
                className="text-white text-sm font-medium px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={() => {
                  if (defaultAddress) {
                    handleProceedToPayment();
                  } else {
                    setMessage(
                      "Please select a default billing address before proceeding."
                    );
                    setMessageType("error");
                    setMessageModalOpen(true);
                  }
                }}
                disabled={!defaultAddress || isLoading}
              >
                {isLoading ? "Processing..." : "Proceed"}
              </button>
              <button
                className="text-sm font-semibold px-4 py-2 rounded-md border border-[#9367D7] text-[#9367D7]"
                onClick={toggleModal} // You can handle the cancel functionality here
              >
                Cancel
              </button>

              {/* Proceed Button */}
              {/* <button
                      className="text-white text-sm font-medium px-4 py-2 rounded-md"
                      style={{
                        background:
                          "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                      }}
                      onClick={handleProceed}
                    >
                      Proceed
                    </button> */}
            </div>
          </div>
        </div>
      )}

      {isAddressModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-hidden">
            <div class="flex justify-between mb-4">
              <h2 className="text-xl font-bold text-left">Billing Address</h2>
              <img
                src={Close_roundClose}
                alt=""
                className="cursor-pointer"
                onClick={toggleAddressModal}
              />
            </div>

            {/* Scrollable Content */}
            <div className="overflow-y-auto max-h-[60vh] pr-1">
              <div className="flex flex-col mb-4 text-sm">
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  id="address"
                  placeholder="Street Address"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />

                <label htmlFor="postalCode">Postal Code</label>
                <input
                  type="text"
                  id="postalCode"
                  placeholder="Postal Code"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={postalCode}
                  onChange={(e) => {
                    const enteredPostalCode = e.target.value;
                    if (enteredPostalCode.length === 6) {
                      setPostalCode(enteredPostalCode);
                      handlePostalCodeChange(e);
                    } else {
                      setPostalCode(enteredPostalCode);
                    }
                  }}
                />

                <label htmlFor="city">City</label>
                <input
                  type="text"
                  id="city"
                  placeholder="City"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />

                <label htmlFor="district">District</label>
                <input
                  type="text"
                  id="district"
                  placeholder="District"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={district}
                  onChange={(e) => setDistrict(e.target.value)}
                />

                <label htmlFor="state">State</label>
                <input
                  type="text"
                  id="state"
                  placeholder="State"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                />

                <label htmlFor="country">Country</label>
                <input
                  type="text"
                  id="country"
                  placeholder="Country"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                />

                <label htmlFor="gstNo">GST No (optional)</label>
                <input
                  type="text"
                  id="gstNo"
                  placeholder="GST Number"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={gstNo}
                  onChange={(e) => setGstNo(e.target.value)}
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-end gap-4 mt-4">
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24 text-white"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleSaveAddress}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {isEditModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-3/5 max-w-lg overflow-hidden">
            <div class="flex justify-between mb-4">
              <span className="text-xl font-bold text-left ">
                Edit Billing Address
              </span>
              <img
                src={Close_roundClose}
                alt=""
                className="cursor-pointer"
                onClick={toggleEditModal}
              />
            </div>

            <div className="overflow-y-auto max-h-96">
              <div className="flex flex-col mb-4 text-xs">
                {/* Address Form */}
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  id="address"
                  placeholder="Street Address"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />

                <label htmlFor="postalCode">Postal Code</label>
                <input
                  type="text"
                  id="postalCode"
                  placeholder="Postal Code"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB]"
                  value={postalCode}
                  // onChange={(e) => setPostalCode(e.target.value)}
                  onChange={(e) => {
                    const enteredPostalCode = e.target.value;

                    // Only call handlePostalCodeChange if the length is exactly 6 digits
                    if (enteredPostalCode.length === 6) {
                      setPostalCode(enteredPostalCode); // Update postal code in the state
                      handlePostalCodeChange(e); // Trigger the postal code change handler
                    } else {
                      setPostalCode(enteredPostalCode); // Update the state even if it's not 6 digits yet
                    }
                  }}
                />

                <label htmlFor="city">City</label>
                <input
                  type="text"
                  id="city"
                  placeholder="City"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={city} // Fill city dynamically
                  onChange={(e) => setCity(e.target.value)} // Update city
                />

                <label htmlFor="district">District</label>
                <input
                  type="text"
                  id="district"
                  placeholder="District"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={district} // Fill district dynamically
                  onChange={(e) => setDistrict(e.target.value)} // Update district
                />

                <label htmlFor="state">State</label>
                <input
                  type="text"
                  id="state"
                  placeholder="State"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={state} // Fill state dynamically
                  onChange={(e) => setState(e.target.value)} // Update state
                />

                <label htmlFor="country">Country</label>
                <input
                  type="text"
                  id="country"
                  placeholder="Country"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={country} // Fill country dynamically
                  onChange={(e) => setCountry(e.target.value)} // Update country
                />

                <label htmlFor="gstNo">GST No (optional)</label>
                <input
                  type="text"
                  id="gstNo"
                  placeholder="GST Number"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={gstNo} // Fill GST number dynamically
                  onChange={(e) => setGstNo(e.target.value)} // Update GST number
                />

                {/* Other fields like City, District, State, Country, GST */}
                {/* Repeat for other fields... */}
              </div>
            </div>
            <div className="flex justify-end mt-4">
              <button
                className="text-sm font-medium py-2 text-white py-2 rounded-md px-3"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleEditAddress}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {isDeleteModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto">
            <h2 className="text-xl font-bold text-center mb-4">
              Confirm Deletion
            </h2>
            <p className="text-lg text-center mb-4">
              Do you want to delete this address?
            </p>
            <div className="flex justify-between gap-4">
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
                onClick={toggleDeleteModal} // Close the modal
              >
                Cancel
              </button>
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleDeleteAccount} // Confirm deletion
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {showPostalModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-hidden">
            <h2 className="text-xl font-bold font-inter text-left mb-4">
              Select Postal Location
            </h2>

            {/* Postal Location List */}
            <div className="space-y-4 overflow-y-auto max-h-[60vh] pr-1">
              {locations.length > 0 ? (
                locations.map((location) => (
                  <div key={location.id} className="flex items-center">
                    <input
                      type="radio"
                      name="postalLocation"
                      value={location.id}
                      checked={selectedLocation?.id === location.id}
                      onChange={() => handleLocationSelection(location)}
                      className="mr-2"
                    />
                    <label className="text-sm">{location.postalLocation}</label>
                  </div>
                ))
              ) : (
                <p className="text-sm text-gray-500">
                  No Postal Locations available.
                </p>
              )}
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-between gap-4 mt-6">
              <button
                onClick={handleModalClose}
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmLocation}
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24 text-white"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {paymentSuccessModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="relative bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto text-center sm:max-w-lg md:max-w-xl sm:px-8 md:px-12">
            {/* Close Icon Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-xl font-bold"
              onClick={() => {
                setPaymentSuccessModalOpen(false);
                if (isPaymentVerified) {
                  navigate("/MyProducts");
                }
              }}
              aria-label="Close"
            >
              &times;
            </button>

            <h1 className="text-2xl font-bold text-green-600 sm:text-3xl mb-5">
              Payment Successful
            </h1>

            <p className="mb-6 text-sm px-2 sm:px-0 text-left">
              Thank you for your payment! Your transaction was successful. Check
              your email for credentials and details, or click continue to
              login.
            </p>

            <div className="w-full flex justify-center">
              <button
                className="bg-purple-600 text-white px-6 py-2 rounded hover:bg-purple-700 w-full sm:w-auto sm:px-10"
                onClick={() => {
                  window.open(
                    `https://${paymentDomain}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                  navigate("/MyProducts");
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {isMessageModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`bg-white p-6 rounded-lg shadow-lg w-2/5 ${
              messageType === "success" ? "border-green-500" : "border-red-500"
            }`}
          >
            {/* <h2 className="text-xl font-bold text-center mb-4">
              {messageType === "success" ? "Success" : "Error"}
            </h2> */}
            <p className="text-lg text-center mb-4">{message}</p>
            <div className="flex justify-center">
              <button
                className="text-sm text-white text-inter font-bold px-6 py-2 rounded-md w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={toggleMessageModal} // Close the modal
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpgradedPlan;
